import { MethodType, ParamsFetchType, GenerateUrlApiType, ResponseType } from 'src_common/browser/apiUtils';
import { GenerateUrlApiParamsType } from 'src_common/server/webDriver/sdkApiWebUtils';
import { buildApiItemDefault, buildArrayDecoderModel, buildModelValidator } from 'src/api/utils/modelUtils';
import {
    decodeString,
    decodeNumber,
    decodeNumberOrUndefined,
    decodeStringArr,
    buildOptionalDecoderModel,
} from 'src/api/utils/commonModelValidators';

const Response200IO = buildModelValidator('decode AutoWithdrawalHistoryDataModel', {
    universe: buildApiItemDefault(decodeString, ''),
    card: buildApiItemDefault(decodeString, ''),
    accountId: buildApiItemDefault(decodeNumber, 0),
    ruleType: buildApiItemDefault(decodeString, ''),
    amount: buildApiItemDefault(decodeNumberOrUndefined, 0),
    reason: buildApiItemDefault(buildOptionalDecoderModel(decodeStringArr), []),
    note: buildApiItemDefault(decodeString, ''),
    actionedBy: buildApiItemDefault(decodeString, ''),
    date: buildApiItemDefault(decodeString, ''),
});

export type AutoWithdrawalHistoryResponseType = Array<{
    universe: string;
    card: string;
    accountId: number;
    ruleType: string;
    amount: number | undefined;
    reason: Array<string> | undefined | null;
    note: string;
    actionedBy: string;
    date: string;
}>;

export const decodeAutoWithdrawalHistoryDataModel = buildArrayDecoderModel(Response200IO);
export type GetWithdrawalViewModelType = AutoWithdrawalHistoryResponseType extends Array<infer Model> ? Model : never;

const decode = (status: number, data: ResponseType): Array<GetWithdrawalViewModelType> => {
    if (status === 200 && data.type === 'json') {
        return decodeAutoWithdrawalHistoryDataModel(data.json);
    } else if (status === 404) {
        throw new Error(`endpoint not found ${status}`);
    }

    throw new Error(`unhandled response ${status} - ${data.type}`);
};

export interface GetWithdrawalHistoryParamsType {
    userId: number;
}

export const getWithdrawalHistory = {
    browser: {
        params: (params: GetWithdrawalHistoryParamsType): ParamsFetchType<GetWithdrawalHistoryParamsType> => {
            return {
                type: MethodType.POST,
                url: '/api-web/automatic-withdrawal-history',
                body: params,
            };
        },
        decode: decode,
    },
    express: {
        method: MethodType.POST,
        urlBrowser: '/api-web/automatic-withdrawal-history',
    },
    generateUrlApi: async (
        params: GenerateUrlApiParamsType<GetWithdrawalHistoryParamsType>
    ): Promise<GenerateUrlApiType> => {
        if (params.userSessionId === null) {
            return {
                passToBackend: false,
                status: 403,
                responseBody: {
                    errorMessage: 'User id invalid',
                },
            };
        }

        const finalUrl = `${params.API_URL}/automatic-withdrawal-rule-audit/${params.API_UNIVERSE}/${params.req.body.userId}`;

        return {
            url: finalUrl,
            passToBackend: true,
            method: MethodType.GET,
        };
    },
};
